var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:{ error: _vm.error }},[_vm._v("\n  "+_vm._s(_vm.title)+"\n  "),(!!_vm.note)?_c('span',{staticClass:"field-note"},[_vm._v("\n    "+_vm._s(_vm.note)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }